import React, { useEffect } from 'react'
import { Drawer, Card, Button, Form, Row, Col } from 'antd'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import { chooseEmailModalFxn, formItemLayout } from '../../../../components/_utils/appUtils'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import { commentToAbstractAuthor } from '../actions'

const RejectionDrawer = (props) => {
  let {
    visible,
    onClose,
    form: { getFieldDecorator, setFieldsValue },
    callback = null,
    abstractId,
    abstract
  } = props
  const dispatch = useDispatch()

  useEffect(() => {
    // Reset date when drawer opens
    if (visible) {
      setFieldsValue({
        sendToAuthorDate: moment()
      })
    }
  }, [visible])

  const inputSchema = {
    fields: [
      {
        label: 'Rejection Date',
        key: 'sendToAuthorDate',
        required: true,
        type: 'date',
        span: 24
      }
    ]
  }

  const handleSubmit = e => {
    e.preventDefault()
    props.form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        chooseEmailModalFxn({
          title: 'Reject Abstract',
          callback: async (email) => {
            valData.abstractId = abstractId
            valData.fromEmail = email
            // Explicitly set status to Rejection so the backend controller handles it
            valData.statusType = 'Rejection'

            let { success } = await dispatch(commentToAbstractAuthor(valData))
            if (success) {
              dispatch({ type: 'START_LOAD_ABSTRACTS' })
              onClose()
              if (callback) callback()
            }
          }
        })
      }
    })
  }

  return (
    <Drawer
      title={`Reject Abstract | ID: ${abstract.onlineAbstractId || 'N/A'}`}
      width={'40%'}
      visible={visible}
      placement='right'
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => (
              <Col span={item.span || 8} key={key}>
                <GetEachFormFields
                  getFieldDecorator={getFieldDecorator}
                  item={item}
                  formItemLayout={formItemLayout}
                />
              </Col>
            ))}
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type='danger' htmlType='submit'>Confirm Rejection</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

export default Form.create()(RejectionDrawer)
